import { instanceWithAuth } from "@/api/index";

function getNoticeList(searchData) {
    return instanceWithAuth.get("/customers/notice-list", { params: searchData });
}

export { getNoticeList };
